import { useEffect, useLayoutEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { setAnchorId } from '../redux/features/navigation/navigationSlice';
import useScrollToView from './useScrollToView';
import { SliceStop } from '../redux/features/orders/ordersSlice';

interface UseStopScrollProps {
  stop: SliceStop;
  setIsCheckInEditing: (value: boolean) => void;
  setIsCheckOutEditing: (value: boolean) => void;
}

interface UseStopScrollReturn {
  stopRef: React.RefObject<HTMLDivElement>;
  inTimeRef: React.RefObject<HTMLDivElement>;
  outTimeRef: React.RefObject<HTMLDivElement>;
}

export const useStopScroll = ({
  stop,
  setIsCheckInEditing,
  setIsCheckOutEditing
}: UseStopScrollProps): UseStopScrollReturn => {
  const dispatch = useAppDispatch();
  const [scrollToView] = useScrollToView();
  const anchorId = useAppSelector((state) => state.navigation.anchorId);
  const isEditLoadOpen = useAppSelector((state) => state.navigation.isEditLoadOpen);
  const isEditTripOpen = useAppSelector((state) => state.navigation.isEditTripOpen);

  const stopRef = useRef<HTMLDivElement>(null);
  const inTimeRef = useRef<HTMLDivElement>(null);
  const outTimeRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if ((isEditLoadOpen || isEditTripOpen) && anchorId) {
      if (anchorId === `stop-check-in-time-${stop.segment_id}-${stop.id}`) {
        setIsCheckInEditing(true);
      }

      if (anchorId === `stop-check-out-time-${stop.segment_id}-${stop.id}`) {
        setIsCheckOutEditing(true);
      }
    }
  }, [anchorId, isEditLoadOpen, isEditTripOpen, stop.segment_id, stop.id, setIsCheckInEditing, setIsCheckOutEditing]);

  useEffect(() => {
    if ((isEditLoadOpen || isEditTripOpen) && anchorId) {
      if (anchorId === stopRef.current?.id) {
        scrollToView(stopRef, 'center');
        setTimeout(() => dispatch(setAnchorId(null)), 500);
      }

      if (anchorId === `stop-check-in-time-${stop.segment_id}-${stop.id}`) {
        setTimeout(() => {
          scrollToView(inTimeRef, 'center');
          setTimeout(() => dispatch(setAnchorId(null)), 500);
        }, 500);
      }

      if (anchorId === `stop-check-out-time-${stop.segment_id}-${stop.id}`) {
        setTimeout(() => {
          scrollToView(outTimeRef, 'center');
          setTimeout(() => dispatch(setAnchorId(null)), 500);
        }, 500);
      }
    }
  }, [anchorId, isEditLoadOpen, isEditTripOpen, stop.segment_id, stop.id, scrollToView, dispatch]);

  return {
    stopRef,
    inTimeRef,
    outTimeRef
  };
};
